import {Component, input, output} from '@angular/core';
import {PlanningRegion, ProgRegionItem} from "../../../../models/planning_region.model";
import {PlanningRegionRowComponent} from "./planning-region-row/planning-region-row.component";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {PlanningRegionEmptyRowComponent} from "./planning-region-empty-row/planning-region-empty-row.component";

@Component({
  selector: '[app-planning-region-week]',
  standalone: true,
  imports: [
    PlanningRegionRowComponent,
    TranslateModule,
    PlanningRegionEmptyRowComponent
  ],
  templateUrl: './planning-region-week.component.html',
  styleUrl: './planning-region-week.component.scss'
})
export class PlanningRegionWeekComponent {
  data = input.required<PlanningRegion>();
  dateValue = input.required<NgbDateStruct>()

  loadRegionData = output<{wedn: string, loading: boolean}>()

  getProgrammesByScreen(screen_id: number, wednesday: string): ProgRegionItem[] {
    return this.data().prog[wednesday][screen_id] || [];
  }

  getMaxProgrammesLength(wednesday: string): number[] {
    const maxLength = Math.max(
      ...this.data().all_screen.map(
        screen => this.getProgrammesByScreen(screen.screen_id, wednesday).length),
      0);
    return Array.from({ length: maxLength + 1 }, (_, i) => i);
  }

  handleLoadRegiondata(event: {wedn: string, loading: boolean}): void {
    this.loadRegionData.emit(event);
  }

  isWeekEmpty(wednesday: string): boolean {
    return !this.data().prog[wednesday]
      || Object.keys(this.data().prog[wednesday]).length === 0
      || Object.values(this.data().prog[wednesday]).every(progList => progList.length === 0);
  }
}
